// extracted by mini-css-extract-plugin
export default {"campaign_banner":"SyFiGvYuQ59ommM9RLEK","campaignBanner":"SyFiGvYuQ59ommM9RLEK","switch_content":"P5oMA2sPt8dsKKyoXdh5","switchContent":"P5oMA2sPt8dsKKyoXdh5"};